import React from 'react';
import { useSelector } from 'react-redux';
import { useSubscription } from '@apollo/react-hooks';
import { LISTEN_USER_UNREAD_COUNT } from 'graphql/chat';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

const UnreadCount = ({ classes, isGroup }) => {
  const user = useSelector((s) => s.user.user);
  const { data } = useSubscription(LISTEN_USER_UNREAD_COUNT, {
    variables: { userId: user.id },
  });
  if (data) {
    const totalCount = data.v_chat_unread_counts;
    if (!isGroup) {
      const inboxChatCount = totalCount
        .filter((i) => i.room.room_name !== 'groups')
        .reduce((memo, r) => {
          return memo + r.count;
        }, 0);
      if (inboxChatCount) {
        return (
          <ListItemSecondaryAction>
            <span className={classes.badge}>{inboxChatCount}</span>
          </ListItemSecondaryAction>
        );
      }
      return null;
    } else if (isGroup) {
      const groupChatCount = totalCount
        .filter((i) => i.room.room_name === 'groups')
        .reduce((memo, r) => {
          return memo + r.count;
        }, 0);
      if (groupChatCount) {
        return (
          <ListItemSecondaryAction>
            <span className={classes.badge}>{groupChatCount}</span>
          </ListItemSecondaryAction>
        );
      }
      return null;
    }
  }
  return null;
};

export default UnreadCount;
